import React from 'react';
import type { ContentItemType } from '../types/entityDetails';
import ContentAssignees from './ContentAssignees';
import ContentItem from './ContentItem';

type ContentDetailsProps = {
  assignees?: unknown[];
  assigneeTitle?: string;
  contentItems: ContentItemType[];
  title?: React.ReactNode;
};

/**
 * @deprecated this should be replaced with composing the entity details
 * using the entity detail components, much like <OpportunityDetailsContent>
 */
export default function ContentDetails({
  assignees = [],
  assigneeTitle = '',
  contentItems = [],
  title = '',
}: ContentDetailsProps) {
  return (
    <>
      {title && <h3 className="pb-4 text-base font-semibold">{title}</h3>}
      <div className="mb-4 grid grid-cols-2 gap-3">
        {contentItems.map((item) => (
          <ContentItem key={item?.key || item?.title} {...item} />
        ))}
        {!!assignees?.length && (
          <ContentAssignees
            className="col-span-full"
            // @ts-expect-error TS(2322) TODO(ts-migrate): Type 'unknown[]' is not assignable to type '{ alia... Remove this comment to see the full error message
            assignees={assignees}
            title={assigneeTitle}
          />
        )}
      </div>
    </>
  );
}
